
<div class="p-grid header-template">
  <div class="disp-icon">
    <fa-icon icon="home"></fa-icon>
  </div>
  <div class="p-col header-info">
    <div class="p-grid p-justify-between">
      <div class="p-col-9 property-search-address">
        <span class="property-search-address-main">
          {{property.Address.Address1}} {{property.Address.Address2}}
        </span>
        {{property.Address.City}}, {{property.Address.State}} {{property.Address.PostalCode}}
        <span class="fav-icon-left">
          <i #favIconEl
            [attr.data-fav-loan-icon-id]="'fav-loan-' + property.PropertyId" 
            [attr.data-fav-loan-flag]="property.IsFavorite"
            [ngClass]="getFavIconClass(property.IsFavorite)" 
            (click)="updateFavorite(favIconEl, property.PropertyId)">
          </i>
        </span>
      </div>
      <div class="p-col-3 strategy-corner strategy-corner-reo">{{property.DispositionStrategyGroup}}</div>
    </div>
    <div class="p-grid p-justify-start">
      <div class="p-col-1"><fa-icon icon="bed"></fa-icon> {{property.BedCount}} Bed</div>
      <div class="p-col-1"><fa-icon icon="bath"></fa-icon> {{property.BathCount}} Bath</div>
      <div class="p-col-10"><fa-icon icon="home"></fa-icon> {{property.SquareFeet}} Sqft</div>              
    </div>     
    <div class="p-grid">
      <div class="p-col-2">
        <span class="property-search-label">Loan Number</span><br/>
        <span *ngIf="!showPropertyIdLink; else propertyIdLink" class="property-search-values">
          {{property.LoanNumber}}
        </span>
        <ng-template #propertyIdLink>
          <span class="property-search-values">
            <a href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}">{{property.LoanNumber}}</a>
          </span>
        </ng-template>
        <a *ngIf="showOpenNewWindowIcon" href="{{routes?.viewTasks}}&property_id={{property.PropertyId}}" target="_blank">
          &nbsp;
          <i class="pi pi-external-link"></i>
        </a>
      </div>
      <div class="p-col-2" ><span class="property-search-label">List Price</span><br/><span class="property-search-values">{{property.ListPrice | currency}}</span>
        <span *ngIf="canAccessListPrice" (mouseover)="listPriceHover($event,op1,property.PropertyId)" (mouseout)="op1.hide()" (click)="op1.hide()"><i class="pi pi-info-circle pointer" style="font-size:18px"
          pTooltip=""></i></span>
      </div>
      <div class="p-col-2">
        <span class="property-search-label">{{statusLabel(property.StatusLabel,property.SubStatusLabel)}}</span><br/>
        <span class="property-search-values">{{statusDisplayValue(property.StatusLabel,property.SubStatusLabel)}}
            <i class="hoverLink" 
            (mouseover)="displayMoreDialog($event, moreStatus, property ,'status')" 
            (mouseout)="moreStatus.hide($event)"
            *ngIf="canShowMoreStatus(property.StatusLabel,property.SubStatusLabel)">...</i>
        </span>
      </div>
      <div class="p-col-3"><span class="property-search-label">Partnership</span><br/><span class="property-search-values">{{property.Lender.PublicName}}</span></div>
      <div class="p-col-3"><span class="property-search-label">Investor ID/Name</span><br/><span class="property-search-values">{{property.InvestorId}} / {{property.InvestorName}}</span></div>
      <div class="p-col-2"><span class="property-search-label">REO #</span><br/><span class="property-search-values">{{property.REONumber}}</span></div>
      <div class="p-col-3"><span class="property-search-label">Parcel #</span><br/><span class="property-search-values">{{property.ParcelNumber || 'Missing'}}</span></div>
      
    </div>
    <p-overlayPanel #op1 appendTo="body" [dismissable]="false" [showCloseIcon]="false" styleClass="reo-change-history-overlay">
      <div class="change-history">
        <h2>Change History</h2>
        <table>
          <tr>
            <th width="10%">Date of Change</th>
            <th width="20%">Date Since Last Reduction</th>
            <th width="12%">Change From</th>
            <th width="8%">Change to</th>
            <th width="20%">Changed By</th>
            <th width="30%">Comments / Change Reason / Expected Return Date</th>
          </tr>
          <tr *ngFor="let listPrice of listPriceChangeLog">
            <td>{{listPrice.CreateDate}}</td>
            <td>{{listPrice.LastChangeDays}}</td>
            <td>{{listPrice.Value1|currency}}</td>
            <td>{{listPrice.Value2|currency}}</td>
            <td>{{listPrice.ChangedBy}}</td>
            <td>{{listPrice.Comments}}</td>
          </tr>
        </table>
      </div>
    </p-overlayPanel>
  </div> 
</div>
<p-overlayPanel #moreStatus [dismissable]="true" appendTo="body">
  <div>{{moreDialogData}}</div>
</p-overlayPanel>